module.exports = __webpack_public_path__ + "static/media/purui_logo.b2898efc.png";